var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"input":(val) => _vm.$emit('input', val)}},'el-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }